import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useState } from "react";

export type SettingsSearch = {
  billing?: "cancel" | "success";
  frame?: string;
};

export const Route = createFileRoute("/settings")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>): SettingsSearch => {
    const billing = search.billing === "success" || search.billing === "cancel" ? search.billing : undefined;
    const frame = typeof search.frame === "string" && search.frame.length > 0 ? search.frame : undefined;
    return {
      ...(billing ? { billing } : {}),
      ...(frame ? { frame } : {})
    };
  },
  head: () => ({
    meta: [
      { title: "Salesko Settings - Workspace & Account" },
      {
        name: "description",
        content: "Manage your Salesko account, computers, Agent configuration, billing, and data."
      },
      { name: "robots", content: "noindex, nofollow" }
    ],
    links: [{ rel: "canonical", href: "https://salesko.ai/settings" }]
  }),
  component: SettingsLayoutRoute
});

function SettingsLayoutRoute() {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
    </QueryClientProvider>
  );
}
